// GetMerchantInfoForProductSize returns the product size's merchant info.
export const MerchantInfoService_GetMerchantInfoForProductSizeLazy = () =>
  import("./service.grpc").then(
    (m) => m.MerchantInfoService_GetMerchantInfoForProductSize
  );
MerchantInfoService_GetMerchantInfoForProductSizeLazy.method =
  "aysa_api.services.merchant_info.v1.MerchantInfoService/GetMerchantInfoForProductSize" as const;
